import { Bell, RefreshCw, Menu } from 'lucide-react';
import { Button } from '@flote/ui';
import { useSidebar } from './sidebar-context';

export function Header() {
  const { toggle } = useSidebar();

  return (
    <header className="flex h-16 items-center justify-between border-b border-border bg-card px-4 shadow-header md:px-6">
      <div className="flex items-center gap-3">
        {/* Hamburger menu button - mobile only */}
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          onClick={toggle}
          aria-label="Toggle menu"
        >
          <Menu className="h-5 w-5" />
        </Button>
        <h1 className="text-base font-semibold md:text-lg">Delivery Management</h1>
      </div>

      <div className="flex items-center gap-1 md:gap-2">
        <Button variant="ghost" size="icon" className="relative h-9 w-9 md:h-10 md:w-10">
          <RefreshCw className="h-4 w-4 md:h-5 md:w-5" />
          <span className="sr-only">Refresh</span>
        </Button>
        <Button variant="ghost" size="icon" className="relative h-9 w-9 md:h-10 md:w-10">
          <Bell className="h-4 w-4 md:h-5 md:w-5" />
          <span className="sr-only">Notifications</span>
        </Button>
      </div>
    </header>
  );
}
